//#region src/cryptography/signature-scheme.ts
const SIGNATURE_SCHEME_TO_FLAG = {
	ED25519: 0,
	Secp256k1: 1,
	Secp256r1: 2,
	MultiSig: 3,
	ZkLogin: 5,
	Passkey: 6,
	Secp521r1: 7
};
const SIGNATURE_SCHEME_TO_SIZE = {
	ED25519: 32,
	Secp256k1: 33,
	Secp256r1: 33,
	Secp521r1: 67,
	Passkey: 33
};
const SIGNATURE_FLAG_TO_SCHEME = {
	0: "ED25519",
	1: "Secp256k1",
	2: "Secp256r1",
	3: "MultiSig",
	5: "ZkLogin",
	6: "Passkey",
	7: "Secp521r1"
};
//#endregion
export { SIGNATURE_FLAG_TO_SCHEME, SIGNATURE_SCHEME_TO_FLAG, SIGNATURE_SCHEME_TO_SIZE };

//# sourceMappingURL=signature-scheme.mjs.map